import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Eye, EyeOff, KeyRound, Mail } from "lucide-react";

import { auth } from "../firebase/firebase";
import { useNotification } from "../contexts/NotificationContext";
import { useAuth } from "../contexts/AuthContext";
import Modal from "../components/Modal";
import { Button } from "../components/ui/button";

import logo from "../assets/images/logo.png";

export default function Authenticate() {
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { showNotification } = useNotification();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setOpen(true);
    }
  }, [user]);

  const handleSignIn = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      showNotification(
        "success",
        `Você entrou como ${userCredential.user.email}`
      );
      navigate("/admin-management");
    } catch (err) {
      showNotification("error", "Usuário inválido.");
    }
  };

  return (
    <>
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 to-slate-950 px-4 py-12 text-white">
        <div className="w-full max-w-md space-y-6 rounded-3xl border border-white/10 bg-white/5 p-8 text-center shadow-2xl backdrop-blur">
          <Link to="/">
            <img className="mx-auto w-48" src={logo} alt="MB Floripa Turismo" />
          </Link>
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-white/60">
              Painel interno
            </p>
            <h1 className="text-2xl font-semibold">Autenticação</h1>
          </div>
          <div className="space-y-4 text-left">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-white">
                E-mail *
              </label>
              <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-3">
                <Mail className="h-4 w-4 text-white/60" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="exemplo@gmail.com"
                  className="h-10 w-full bg-transparent text-sm outline-none placeholder:text-white/40"
                />
              </div>
            </div>
            <div className="space-y-2">
              <label className="text-sm font-semibold text-white">
                Senha *
              </label>
              <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-3">
                <KeyRound className="h-4 w-4 text-white/60" />
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="senha1234"
                  className="h-10 w-full bg-transparent text-sm outline-none placeholder:text-white/40"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="text-white/60"
                >
                  {showPassword ? (
                    <EyeOff className="h-4 w-4" />
                  ) : (
                    <Eye className="h-4 w-4" />
                  )}
                </button>
              </div>
            </div>
          </div>
          <Button className="w-full" onClick={handleSignIn}>
            Entrar
          </Button>
        </div>
      </div>
      {user && (
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          onClick={() => navigate("/admin-management")}
          title={user.email}
          description="Você já possui uma sessão ativa, deseja continuar?"
          closeButton="Não"
          continueButton="Continuar"
        />
      )}
    </>
  );
}
